import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./MergingUIHelpers";

const DistributionMergingUIContext = createContext();

export function useDistributionMergingUIContext() {
  return useContext(DistributionMergingUIContext);
}

export const DistributionMergingUIConsumer =
  DistributionMergingUIContext.Consumer;

export function DistributionMergingUIProvider({
  distributionMergingUIEvents,
  children,
}) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initDistributionMerging = {
    name: "",
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initDistributionMerging,
    newDistributionMergingIndividuButtonClick:
      distributionMergingUIEvents.newDistributionMergingIndividuButtonClick,
    openEditDistributionMergingIndividualPage:
      distributionMergingUIEvents.openEditDistributionMergingIndividualPage,
    openEditDistributionMergingOrganizationPage:
      distributionMergingUIEvents.openEditDistributionMergingOrganizationPage,
    openDeleteDistributionMergingPage:
      distributionMergingUIEvents.openDeleteDistributionMergingPage,
    newDistributionMergingOrganizationButtonClick:
      distributionMergingUIEvents.newDistributionMergingOrganizationButtonClick,
  };

  return (
    <DistributionMergingUIContext.Provider value={value}>
      {children}
    </DistributionMergingUIContext.Provider>
  );
}
